// @ts-nocheck
import React from 'react';

const Section2 = ({
  // @ts-ignore
  // @ts-ignore
  title, text1, text2, text3 }) => {
  return (
    <>
      <section className="pb-5">
        <div className="text-justify hyphens-auto" id="section1">
          <div className="pt-3 pb-5 text-lg font-semibold">
            {title}
          </div>
          <div className="pb-2">
            {text1}
          </div>
          {text2 && (
            <div className="pb-2">
              {text2}
            </div>
          )}
          {text3 && (
            <div className="pb-2">
              {text3}
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Section2;
